import * as React from 'react';

export const SplashHero = () => {
	return (
		<div
			className="fi-splash-hero-image"
			dangerouslySetInnerHTML={{ __html: window.findaConnector.splashHero }}
		/>
	);
};
